export default "__VITE_ASSET__C$7VM9xn__"